export default (state = [], action) => {
  if (action.type === "FETCH_CITIES") {
    return action.cities;
  }

  return state;
};


// WEBPACK FOOTER //
// ./src/website/cities.reducer.js